import MoveFileModal from "./MoveFileModal";

export default MoveFileModal;
